/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_History_TitleInputs */

const vi_sales_return_history_title = /** @type {(inputs: Sales_Return_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch sử trả hàng`)
};

/**

* @param {Sales_Return_History_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_history_title = /** @type {((inputs?: Sales_Return_History_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_History_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_history_title(inputs)
});